
    import * as React from 'react';

    const Preorder24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M20.437 6.63l.249-3.817 1.069.07-.404 6.193-5.893-1.946.336-1.017 3.85 1.27A8.929 8.929 0 1020.928 12l1.072.001c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2a9.992 9.992 0 018.437 4.63zm-8.326 6.037H16V14h-5V8h1.111v4.667z" /></svg>
        </div>
      );
    };

    Preorder24.displayName = 'Preorder24';

    export default Preorder24;
  